<template>
  <v-card class="mx-auto my-12" max-width="800">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text v-if="sheets.length === 0">
      No sheets available for this parashah
      <a href="/sheets" v-if="$route.path === '/'">
        see the archives for more
      </a>
    </v-card-text>
    <v-simple-table v-else>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-left">Link</th>
            <th class="text-left">Audio</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in sheets"
            :key="item._id"
            :id="item.name.toLowerCase().replace(/\s/g, '_')"
          >
            <td>{{ item.name }}</td>
            <td style="width: 150px;">
              <a
                target="_blank"
                rel="noopener noreferrer"
                :href="getAudioLink(item.file)"
                @click="gaLink(item)"
              >
                Download
              </a>
            </td>
            <td style="width: 150px;">
              <audio-dialog
                v-if="item.audio"
                :src="getAudioLink(item.audio)"
                :duration="item.audioDuration"
              ></audio-dialog>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import AudioDialog from "./AudioDialog";
export default {
  props: {
    sheets: Array,
    title: String,
  },
  components: {
    AudioDialog,
  },
  mounted() {
    if (this.$route.hash) {
      this.$vuetify.goTo(this.$route.hash, { offset: 10 });
    }
  },
  methods: {
    getLink(id) {
      return (
        (process.env.VUE_APP_apiUrl || "") +
        "/api/sheet/" +
        encodeURIComponent(id)
      );
    },
    getAudioLink(id) {
      return "https://d4odgszxjhf3m.cloudfront.net/" + id;
    },
    gaLink(item) {
      this.$ga.event("sheet", "download", item.name, 1);
    },
  },
};
</script>
